var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6469 0.365608L15.6844 4.39686C16.5594 5.41561 15.4531 6.77186 14.3313 6.18123L13.3438 8.15623L7.71875 2.71873L9.83125 1.67498C9.25 0.640608 10.5406 -0.634392 11.6469 0.365608ZM12.9623 14.3313L1.64978 3.01878C0.374777 1.71878 2.15603 -0.124969 3.59353 1.13753L14.906 12.45C16.2185 13.9063 14.4373 15.6875 12.9623 14.3313ZM0 16L4.375 9.23438L6.8 11.6531L0 16Z",
    fill: "#6B6C7E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#6B6C7E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpin);
export default __webpack_public_path__ + "static/media/icon-unpin.38972ce405b2a50abdc9faa0fdf1bf45.svg";
export { ForwardRef as ReactComponent };